import React from "react";
import {Route, Routes} from "react-router-dom";
import View3D from "./pages/View";
import Home from "./pages/Home";

const MainRouter = () => {
    return (
        <div>
            <View3D/>
        </div>
    );
};

export default MainRouter;